<template>
	<contentBox v-if="!loadError" v-bind:loading="loading">
		<contentTitle v-if="overlay" label="EDIT OVERLAY" v-bind:close="routeClose">
			<h2 class="text-white font-weight-light pb-2">{{overlay.name}}</h2>
		</contentTitle>
		<contentBody v-if="overlay" v-bind:locked="token === null || !isAdmin">
			<div class="p-3">
				<div class="lock-block" v-if="token === null || !isAdmin">
					<div class="row mx-0 hover-dk" v-on:click="routeLogin">
						<div class="col-2 text-center my-auto">
							<i class="material-icons text-light mr-3 md-36">account_box</i>
						</div>
						<div class="py-3 col-10 pl-0 pr-3 py-3">
							<h5 class="mb-0 text-white">Sign in to edit</h5>
							<h5 class="mb-0 font-weight-light text-light">You do not have permission to edit this record</h5>
						</div>
					</div>
				</div>
				<div v-if="token !== null && isAdmin" class="category-body">
					<div v-if="mode === 'detailsEdit'" class="section section-bold">
						<div class="section-title">
							Edit Overview
							<span v-on:click="setMode(null)" class="category-title-btn"><i class="material-icons md-14">close</i></span>
						</div>
						<div class="section-body">
							<div class="category">
								<div class="category-title">DESCRIPTION</div>
								<div class="property-row">
									<textarea class="form-control" rows="10" v-model="rec.description"></textarea>
								</div>
							</div>
						</div>
						<div class="section-footer">
							<button v-on:click="saveDetails" class="btn btn-sm btn-primary float-right">Save</button>
						</div>
					</div>
					<div v-else class="section">
						<div class="section-title">
							Overview
							<span v-on:click="setMode('detailsEdit')" class="category-title-btn"><i class="material-icons md-14">edit</i></span>
						</div>
						<div class="section-body">
							<div class="category">
								<div class="category-title">DESCRIPTION</div>
								<div class="property-row">
									<div v-if="overlay.description" class="text-description">{{overlay.description}}</div>
									<span v-else class="undef">
										-
									</span>
								</div>

							</div>
							<div v-if="overlay.details" class="category">
								<div class="category-title">DETAILS</div>
								<div v-for="(detail, index) in overlay.details" class="property-row">
									<label>{{detail.name}}</label>
									<div class="property-value-right property-locked">
										{{detail.value || '-'}}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="overlay.references" v-for="(ref, idx) in overlay.references">
						<div v-if="mode === 'referenceDelete' && referenceDeleteInd === idx" class="section section-bold">
							<div class="section-title">
								Delete Reference {{idx+1}}
								<span v-on:click="setMode(null)" class="category-title-btn"><i class="material-icons md-14">close</i></span>
							</div>
							<div class="section-body">
								<div class="property-row">
									Are you sure you want to delete this reference?
								</div>
							</div>
							<div class="section-footer">
								<button v-on:click="referenceDeleteSubmit" class="btn btn-sm btn-danger float-right">Delete</button>
							</div>
						</div>
						<referenceForm 
							v-else-if="mode === 'referenceEdit' && referenceEditInd === idx" 
							@close="setMode(null)" 
							@submit="referenceSave"
							:reference="overlay.references[idx]" 
							submitLabel="Save" 
							:title="`Edit Reference ${idx+1}`"/>
						<div v-else class="section">
							<div class="section-title">
								Reference {{idx+1}}
								<span v-on:click="referenceDelete(idx)" class="category-title-btn"><i class="material-icons md-14">delete</i></span>
								<span v-on:click="referenceEdit(idx)" class="category-title-btn"><i class="material-icons md-14">edit</i></span>
							</div>
							<div class="section-body">
								<div class="category">
									<div class="category-title">DESCRIPTION</div>
									<div v-if="ref.description" class="property-row">
										{{ref.description}}
									</div>
									<span v-else class="undef">
										-
									</span>
								</div>
								<div class="category">
									<div class="category-title">URL</div>
									<div v-if="ref.url" class="property-row word-wrap-break">
										{{ref.url}}
									</div>
									<span v-else class="undef">
										-
									</span>
								</div>
							</div>
						</div>
					</div>
					<referenceForm 
						v-if="mode === 'referenceAdd'" 
						@close="setMode(null)" 
						@submit="referenceAdd"
						submitLabel="Add" 
						title="Add Reference"/>
					<div v-else class="mb-3">
						<button v-on:click="setMode('referenceAdd')" class="btn btn-dark btn-sm">Add Reference</button>
					</div>
				</div>
			</div>
		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import referenceForm from './reference-form';

export default {
	name: 'overlay-edit',
	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		referenceForm,
	},
	computed: {
		isAdmin: function(){
			return this.$store.state.agent.rec && this.$store.state.agent.rec.role.name && this.$store.state.agent.rec.role.name === 'admin';
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		overlay: function() {
			return this.$store.state.overlay.rec;
		},
		mapBounds:function(){
			return this.$store.state.map.bounds;
		},
		mapCenter: function(){
			return {lat:this.$store.state.map.params.lat,lng:this.$store.state.map.params.lng};
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		},
		mapZoom: function(){
			return this.$store.state.map.params.zoom;
		},
		location:function(){
			return window.location.href;
		},
		mapMoveDone:function(){
			return this.$store.state.map.fitBoundsDone;
		},
		flyToDone:function(){
			return this.$store.state.map.flyToDone;
		},
		mapFeatureQueryFound:function(){
			return this.$store.state.map.featureQueryFound;
		},
	},
	created: function(){
		this.loading = false;
		this.getRec();
	},
	data: function(){
		return {
			loading:false,
			loadError:null,
			mode:null,
			rec:null
		}
	},
	beforeDestroy: function(){
		this.$store.dispatch('OVERLAY_HIGHLIGHT_CLEAR',{});
		this.$store.dispatch('OVERLAY_VISIBLE_CLEAR',{});
		this.$store.dispatch('MAP_LAYER_GROUP_VISIBLE_ON','zoning');
	},
	methods: {
		checkInside:function(){
			const bbox = this.overlay.bounds.bbox;
			const bounds = this.mapBounds;

			if (this.mapZoom >= 17 || this.mapZoom <= 12) return false;
			if (bbox[1] > bounds._ne.lat || bbox[3] < bounds._sw.lat || 
				bbox[0] > bounds._ne.lng || bbox[2] < bounds._sw.lng){
				return false;
			}

			return true;
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.overlay || !this.mapLoaded) return;
			this.ready();
		},
		checkZoom:function(){
			if (this.mapZoom >= 15 || this.mapZoom <= 12) return false;
			return true;
		},
		getRec: function(){
			this.loadError = null;
			this.loading = true;
			this.$store.dispatch('OVERLAY_GET', {
				id: this.$route.params.id
			}).catch((error)=>{
				this.loadError = error;
			});
		},
		highlight:function(){
			this.$store.dispatch('OVERLAY_VISIBLE');
			this.$store.dispatch('OVERLAY_HIGHLIGHT',{});
		},
		ready:function(){
			if (!this.checkInside()) this.zoomTo();
			else if (!this.checkZoom()){
				this.$store.dispatch('MAP_FLY_TO',{
					zoom:15
				});
			}
			else this.highlight();
			this.$store.dispatch('MAP_LAYER_GROUP_VISIBLE_OFF','zoning');
			this.updateTitleTag();
		},
		referenceAdd:async function(reference){
			this.loading = true;
			await this.$store.dispatch('OVERLAY_REFERENCE_ADD', {
				id:this.$route.params.id, 
				reference:reference,
				sourceId:this.overlay.sourceId,
				layerId:this.overlay.layerId,
			});
			this.loading = false;
			this.setMode(null);
		},
		referenceDelete:function(ind){
			this.setMode('referenceDelete');
			this.referenceDeleteInd = ind;
		},
		referenceSave:async function(reference){
			this.loading = true;
			const referenceId = this.overlay.references[this.referenceEditInd].id;
			await this.$store.dispatch('OVERLAY_REFERENCE_SAVE', {
				id:this.$route.params.id, 
				referenceId:referenceId,
				reference:reference
			});
			this.loading = false;
			this.setMode(null);
		},
		referenceDeleteSubmit:async function(){
			this.loading = true;
			const referenceId = this.overlay.references[this.referenceDeleteInd].id;
			await this.$store.dispatch('OVERLAY_REFERENCE_DELETE', {
				id:this.$route.params.id, 
				referenceId:referenceId
			});
			this.loading = false;
			this.setMode(null);
		},
		referenceEdit:function(ind){
			this.setMode('referenceEdit');
			this.referenceEditInd = ind;
		},
		routeClose:function(){
			this.$router.push({
				name: 'overlay', 
				params:{id:this.$route.params.id}
			});
		},
		routeLogin:function(){
			this.$router.push({
				name: 'auth', 
				params:{}
			});
		},
		saveDetails:async function(){
			this.loading = true;
			await this.$store.dispatch('OVERLAY_SAVE', {
				id:this.$route.params.id, 
				rec:this.rec
			});
			this.loading = false;
			this.setMode(null);
		},
		setMode:function(mode){
			this.mode = mode;
		},
		updateTitleTag:function(){
			document.title = this.overlay.name+' edit - Scoutred Maps';
		},
		zoomTo:function(){
			this.$store.dispatch('OVERLAY_ZOOM_TO',{coords:this.mapCenter});
		},
	},
	watch: {
		$route:function(toRoute, fromRoute){
			if (fromRoute && toRoute.params.id !== fromRoute.params.id){ // route resource has changed
				this.getRec();
			}
		},
		mapLoaded:function(){
			this.checkReady();
		},
		overlay:function(toRec, fromRec){
			this.checkReady();
			if (this.overlay){
				this.rec = JSON.parse(JSON.stringify(this.overlay))
				this.loading = false;
			}
		},
		mapMoveDone:function(){
			this.highlight();
		},
		flyToDone:function(){
			this.highlight();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/overlay/overlay-edit.vue